// extracted by mini-css-extract-plugin
module.exports = {"inspirationWrapper":"Inspirations_inspirationWrapper__njNrV","inspirationContainer":"Inspirations_inspirationContainer__AZOh2","content":"Inspirations_content__tPeu_"};